import React from 'react'
import { useFormikContext } from 'formik'
import { BasicTextField, BasicTextFieldProps } from '../BasicTextField'

export const FormikTextField = <T extends unknown>({
  name,
  label,
  ...rest
}: BasicTextFieldProps<T>) => {
  const { values, touched, errors, handleChange, handleBlur } = useFormikContext<T>()

  const isTouched = touched[name] as boolean
  const error = errors[name] as string | undefined

  return (
    <BasicTextField
      name={name}
      value={values[name]}
      error={Boolean(isTouched && error)}
      helperText={isTouched && error}
      placeholder={label}
      label={label}
      onChange={handleChange(name)}
      onBlur={handleBlur(name as string)}
      {...rest}
    />
  )
}
